import sessiongetAccountId from './session.getAccountId';
import sessionGetAuthRole from './session.getAuthRole';
import sessionGetPredicate from './session.getPredicate';
import sessionGetError from './session.getError';

export const getAccountId = sessiongetAccountId;
export const getAuthRole = sessionGetAuthRole;
export const getPredicate = sessionGetPredicate;
export const getError = sessionGetError;
